export default __webpack_public_path__ + "static/step-2-bee8c06ce27a9052f7860912ce8a14fb.gif";